import { useBackend } from "../../services";

export const useResetAllAlbumsClosestExchangeRate = () => {
  const { post } = useBackend();
  return async () => post("admin/resetAllAlbumsClosestExchangeRate", {});
};
